import { useSelector } from 'react-redux'
import useAdditionalSaleFormData from '../../Components/AdditionalSales/useAdditionalSaleFormData'
import { selectAdditionalSaleDataByName } from '../SubscriptionFormSelectors'
import { useTranslation } from 'react-i18next'

const useLeadsScript = () => {
  const { retrieveProductsListOfSale } = useAdditionalSaleFormData()
  const { t } = useTranslation()
  const retrieveMaxCreditsOfProducts = products => {
    return products.reduce((max, product) => {
      return (product.credits?.credits || 0) > (max.credits?.credits || 0) ? product : max
    }, products[0])
  }

  const leadScripts = {}

  // Axa Assistance
  const productListLeadAssistance = retrieveProductsListOfSale('leadAssistance')
  const productWithHighestCreditsAssistance = retrieveMaxCreditsOfProducts(productListLeadAssistance)
  const currentLeadAssistanceData = useSelector(selectAdditionalSaleDataByName('leadAssistance'))
  let totalCreditsAssistance = productWithHighestCreditsAssistance?.credits?.credits || null
  const assistanceLeadSold = currentLeadAssistanceData?.zohoContractDetailId?.length > 0
  if (assistanceLeadSold) {
    const productId = currentLeadAssistanceData?.assistanceId
    const product = productListLeadAssistance.find(prod => prod.id === productId)
    if (product?.credits?.credits) {
      totalCreditsAssistance = product.credits.credits
    }
  }

  if (productListLeadAssistance.length > 0) {
    leadScripts.leadAssistance = {
      name: 'leadAssistance',
      title: 'Axa Assistance',
      description: t('subscriptionForm:credit_booster.axa'),
      credits: totalCreditsAssistance,
      sold: assistanceLeadSold,
      icon: 'sales-leadAssistance',
    }
  }

  // Carbon Offset
  const productListLeadCarbonOffset = retrieveProductsListOfSale('leadCarbonOffset')
  const productWithHighestCreditsCarbonOffset = retrieveMaxCreditsOfProducts(productListLeadCarbonOffset)
  const currentLeadCarbonOffsetData = useSelector(selectAdditionalSaleDataByName('leadCarbonOffset'))
  let totalCreditsCarbonOffset = productWithHighestCreditsCarbonOffset?.credits?.credits || null
  const carbonOffsetLeadSold = currentLeadCarbonOffsetData?.zohoContractDetailId?.length > 0
  if (carbonOffsetLeadSold) {
    const productId = currentLeadCarbonOffsetData?.offsetId
    const product = productListLeadCarbonOffset.find(prod => prod.id === productId)
    if (product?.credits?.credits) {
      totalCreditsCarbonOffset = product.credits.credits
    }
  }

  if (productListLeadCarbonOffset.length > 0) {
    leadScripts.leadCarbonOffset = {
      name: 'leadCarbonOffset',
      title: 'Carbon Offset',
      description: t('subscriptionForm:credit_booster.offset'),
      credits: totalCreditsCarbonOffset,
      sold: carbonOffsetLeadSold,
      icon: 'sales-leadCarbonOffset',
    }
  }

  // Telecom
  const productListLeadTelecom = retrieveProductsListOfSale('leadTelecom')
  const productWithHighestCreditsTelecom = retrieveMaxCreditsOfProducts(productListLeadTelecom)
  const currentLeadTelecomData = useSelector(selectAdditionalSaleDataByName('leadTelecom'))
  const telecomLeadSold = currentLeadTelecomData?.zohoContractDetailId?.length > 0

  if (productListLeadTelecom.length > 0) {
    leadScripts.leadTelecom = {
      name: 'leadTelecom',
      title: 'Lead Telecom',
      description: t('subscriptionForm:credit_booster.leadTelecom'),
      credits: productWithHighestCreditsTelecom?.credits?.credits || null,
      sold: telecomLeadSold,
      icon: 'sales-leadTelecom',
    }
  }

  // Energie
  const productListLeadEnergy = retrieveProductsListOfSale('leadTelecomEnergy')
  const productWithHighestCreditsEnergy = retrieveMaxCreditsOfProducts(productListLeadEnergy)
  const currentLeadEnergyData = useSelector(selectAdditionalSaleDataByName('leadTelecomEnergy'))
  const telecomEnergyLeadSold = currentLeadEnergyData?.zohoContractDetailId?.length > 0

  if (productListLeadEnergy.length > 0) {
    leadScripts.leadTelecomEnergy = {
      name: 'leadTelecomEnergy',
      title: 'Lead Energie',
      description: t('subscriptionForm:credit_booster.leadEnergy'),
      credits: productWithHighestCreditsEnergy?.credits?.credits || null,
      sold: telecomEnergyLeadSold,
      icon: 'sales-telecomEnergy',
    }
  }

  // Assurance
  const productListLeadAssurance = retrieveProductsListOfSale('leadAssurance')
  const productWithHighestCreditsAssurance = retrieveMaxCreditsOfProducts(productListLeadAssurance)
  const currentLeadAssuranceData = useSelector(selectAdditionalSaleDataByName('leadAssurance'))
  const telecomAssuranceLeadSold = currentLeadAssuranceData?.zohoContractDetailId?.length > 0

  if (productListLeadAssurance.length > 0) {
    leadScripts.leadAssurance = {
      name: 'leadAssurance',
      title: 'Lead Assurance',
      description: t('subscriptionForm:credit_booster.leadAssurance'),
      credits: productWithHighestCreditsAssurance?.credits?.credits || null,
      sold: telecomAssuranceLeadSold,
      icon: 'sales-leadAssurance',
    }
  }

  return {
    leadScripts,
  }
}

export default useLeadsScript
